import { render, staticRenderFns } from "./AccountSet.vue?vue&type=template&id=5704b392"
import script from "./AccountSet.vue?vue&type=script&lang=js"
export * from "./AccountSet.vue?vue&type=script&lang=js"
import style0 from "./AccountSet.vue?vue&type=style&index=0&id=5704b392&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AccountSet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports